import { PAGES } from '../lib/config';
import { FOUR_K_FAQ } from '../lib/content';
import { ToolPageShell } from '../components/ToolPageShell';
import { UpscalerApp } from '../components/UpscalerApp';

export function ImageUpscaler4kPage() {
  const page = PAGES.find((p) => p.path === '/image-upscaler-4k')!;
  const extra = (
    <>
      <div className="rounded-xl border border-primary-100/20 bg-primary-50/5 p-4 text-sm text-text-secondary">
        <strong className="text-text-primary">Free preview uses 2×.</strong> 4× and 8K output are
        planned Pro capabilities and depend on the original image resolution and quality.
      </div>
      <h2 className="text-2xl font-bold text-text-primary">About 4K image upscaling</h2>
      <p>
        4K usually means 3840 × 2160 pixels and 8K means 7680 × 4320 pixels. Reaching those
        dimensions requires both a 4×/8× upscale factor and a good-quality original file. Higher
        factors are not available on the free plan.
      </p>
      <h3 className="text-xl font-semibold text-text-primary">Free vs. Pro output limits</h3>
      <p>
        Free users can upscale 2×. 4×, 8K-ready output, and high-resolution downloads are planned
        for Pro.
      </p>
      <p>For the best results, start with the highest-quality original file you have.</p>

      <h3 className="text-xl font-semibold text-text-primary">Try the free preview</h3>
      <UpscalerApp uploadLabel={page.uploadLabel} showScale={false} />
      <p className="text-center text-xs text-text-muted">
        Free preview uses 2×. 4×/8K is planned for Pro.
      </p>
    </>
  );
  return <ToolPageShell page={page} faqItems={FOUR_K_FAQ} extraContent={extra} hideApp />;
}
